import { identity } from 'lodash';
import { parse } from 'content-type';
import { ACCEPT } from 'http-header-fields';

const isText = type => type && parse(type).type.split('/')[0] === 'text';

export default () => ({ options }) => (
  isText(options.headers[ACCEPT])
    ? response => response.text()
    : identity
);



// WEBPACK FOOTER //
// ./src/Api/middleware/text.js